module.exports = __webpack_public_path__ + "img/accessory_item_08.d72246ba.svg";